import { ICourse } from 'interface/course';
import { get, post } from './api';
import { toastError, toastSuccess } from 'utils/reduxToast';

export interface IQuestion {
  question: string;
  answer: string;
}

export interface IResponse {
  learner: IQuestion[];
  producer: IQuestion[];
}

export interface IData {
  name: string;
  email: string;
  cou_hash: string;
  message: string;
  title: string;
}

export const getQuestions = (): Promise<IResponse> => {
  return get({ url: '/user/help' }).then((response) => response.data.data);
};

export const getCourseOptions = (): Promise<ICourse[]> => {
  return get({
    url: `/learner/course/search?size=999`,
  }).then((response) => response.data.data);
};

export const saveMessage = (data: IData) => {
  return post({ url: '/user/help', data })
    .then((response) => {
      toastSuccess('Solicitação enviada com sucesso!');
      return response;
    })
    .catch(() => toastError('Não foi possível enviar a solicitação no momento'));
};
